export const defaultContext = {
  auth: {
    balance: {
      amount: '', currency: ''
    },
    casino_id: "",
    currency_id: "",
    game_id: "",
    ip: "",
    login_params: 2,
    player_id: "",
    player_name: "",
    provider_id: null,
    session_id: "",
  },
  train: '',
  config: {
    minbet: '0',
    maxbet: '100',
    prec: 0,
  },
  stake: "0.00",
  settings: {
    stake: "0.00",
    numOfBets: "",
    cashoutAt: "0",
    audio: { music: true, sound: true, volume: '0.5' }
  },
  autoConfigs: {
    numOfBets: "",
    cashoutAt: "0",
  },
  autoCurrent: {
    betsRemained: "",
    isAutoOn: false,
  },
  audio: {
    music: true,
    sound: true,
    volume: "0.5",
  },
  defaultPlaceBet: {
    bet: "",
    currency: "",
    state: "",
    error: "0",
  },
  placebet: {
    bet: 0,
    error: {
      code: 0,
      status: '',
      message: ''
    }
  },
  funcs: {
    stopAuto: null,
    handleStake: null,
    setAudio: null
  },
  history: {
    my: [],
    all: [],
    high: [],
  },
  bet: {
    win: 0,
    profit: 0
  },
  astroSocketMessages: null,
}
